import api from '../services/config/api';
import { getItemStorage } from './storage';
import { tokenKey } from 'constants/storage';
import { objToQuery } from 'utils/query';
import { IDemandServiceType } from 'types/demands';

export const getSlaSuggestion = () => api.get<string>('/solicitacao');

export interface IReportGen {
  periodoInicial: string;
  periodoFinal: string;
}

export const generateReport = (data: IReportGen) =>
  new Promise<{
    headers: Headers;
    data: Blob;
  }>((resolve, reject) => {
    let headers = null as null | Headers;

    fetch(`${api.defaults.baseURL}/solicitacao/export-excel?${objToQuery(data)}`, {
      headers: {
        Authorization: `Bearer ${getItemStorage(tokenKey)}`,
      },
    })
      .then(e => {
        headers = e.headers;
        return e.blob();
      })
      .then(e => {
        resolve({ headers: headers as Headers, data: e });
      })
      .catch(reject);
  });

export const getIDemandServiceTypes = () => api.get<IDemandServiceType[]>('/service-type');
